<template>
  <el-table :data="products" style="width: 100%" :default-sort = "{ prop: 'title', order: 'ascending' }" empty-text="No associated products were found.">
    <el-table-column label="Product">
      <template slot-scope="props">
        <router-link :to="{ name: 'products-id', params: { id: props.row.id } }">{{ props.row.title }}</router-link>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    products: Array,
  },
}
</script>

<style>

</style>
